<template>
  <div class="topup-form">
    <div class="topup-form-frame">
      <h1>{{ $t('view.contacts.header') }}</h1>
      <contacts-form />
      <contacts-list />
    </div>
  </div>
</template>

<script>
import ContactsForm from '@/plus/components/Contacts/Form'
import ContactsList from '@/plus/components/Contacts/List'
import ContactsMixin from '@/common/mixins/views/Contacts.mixin'

export default {
  name: 'Contacts',
  mixins: [ContactsMixin],
  components: {
    ContactsList,
    ContactsForm
  }
}
</script>
